import React, { Component } from "react";
import "./ScheduleCard.less";

class ScheduleCard extends Component {
  render() {
    const { date, month, day, onClick, active } = this.props;

    return (
      <div
        className={`schedule-card ${active ? "active" : ""}`}
        onClick={onClick}
      >
        <p className="month">{month}</p>
        <p className="date">{date}</p>
        <p className="day">{day}</p>
      </div>
    );
  }
}

export default ScheduleCard;
